import * as React from 'react';
import { ImageLoadState } from '@fluentui/react/lib/Image';
import type { FileLinkThumbnailViewProps } from '../schema';

export default function useFileLinkThumbnailViewState({
    thumbnailUrl,
}: FileLinkThumbnailViewProps) {
    const [loadState, setLoadState] = React.useState<ImageLoadState>(ImageLoadState.notLoaded);

    const onImageLoadStateChanged = React.useCallback(
        (loadState: ImageLoadState) => {
            setLoadState(loadState);
        },
        [loadState]
    );

    return {
        imageProps: {
            src: thumbnailUrl,
            onLoadingStateChange: onImageLoadStateChanged,
        },
        shouldShowThumbnail: !!thumbnailUrl && loadState !== ImageLoadState.error,
    };
}
